import * as React from 'react';
import moment from 'moment';

import { AnimatedButton } from 'components/Map/AnimatedButton';
import styles from './CreateItineraryFromPinsButton.module.css';
import { useTranslation } from 'react-i18next';
import { useUrlQueryDisplayState } from 'components/Map/useUrlQueryDisplayState';
import MapDisplayContextService from 'components/Map/MapDisplayContextService';

export const CreateItineraryFromPinsButton = ({
  pinKeys,
  onCloseChat,
}: {
  pinKeys: string[];
  onCloseChat: () => void;
}) => {
  const { t } = useTranslation();
  const { pushUrlParams } = useUrlQueryDisplayState();
  const itinerary = {
    id: '',
    digital_map_id: '',
    title: '',
    date_itineraries: [
      {
        date: moment().format('YYYY-MM-DD'),
        items: pinKeys.map((pinKey) => ({
          pin_key: pinKey,
          time: '',
          duration: '',
          travel_time: '',
        })),
      },
    ],
  };

  return (
    <div className={styles.container}>
      <AnimatedButton
        className={styles.btn}
        clickedClassName={styles.clicked}
        onClick={() => {
          MapDisplayContextService.setNewItinerary(itinerary);
          pushUrlParams({ pg: 'ITINERARIES.EDIT', nav: 'map' });
          onCloseChat();
        }}
      >
        <img src="/static/images/map/route.svg" alt="" className={styles.icon} />
        <div className={styles.text}>{t('Create Itinerary from Items')}</div>
      </AnimatedButton>
    </div>
  );
};
